import { render, staticRenderFns } from "./FilesTable.vue?vue&type=template&id=5d78d6dd&scoped=true&"
import script from "./FilesTable.vue?vue&type=script&lang=ts&"
export * from "./FilesTable.vue?vue&type=script&lang=ts&"
import style0 from "./FilesTable.vue?vue&type=style&index=0&id=5d78d6dd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d78d6dd",
  null
  
)

export default component.exports